export class Reservation {
    constructor(
        public readonly id: string,
        public readonly batchId: string,
        public readonly expireAt: string
    ) {
    }
}
